import BaseModel from './BaseModel';
import {ATTRIBUTE_TYPES, HitContainerAttribute} from '../../components';
import {ProjectPart} from './index';

export default class PeriodicBill extends BaseModel {
  constructor({
    id,
    number,
    designation,
    beginDate,
    endDate,
    closed,
    salesAmount,
    projectPart,
    sortOrder,
  }) {
    super(id, number, designation);
    this.beginDate = beginDate;
    this.endDate = endDate;
    this.closed = closed;
    this.salesAmount = salesAmount;
    this.projectPart = projectPart ? new ProjectPart(projectPart) : null;
    this.sortOrder = sortOrder;
  }

  static get config() {
    const config = BaseModel.config;
    config['addable'] = false;
    config['importable'] = false;
    config['duplicatable'] = false;
    config['browsable'] = false;
    return config;
  }

  get config() {
    const config = BaseModel.config;
    config['addable'] = false;
    config['importable'] = false;
    config['duplicatable'] = false;
    config['browsable'] = false;
    return config;
  }

  static get fkName() {
    return 'bill_id';
  }
  static get apiRoute() {
    return 'project_part_bill';
  }
  static get detailPageRoute() {
    return 'periodicBilling';
  }
  static get listPageRoute() {
    return undefined;
  }
  get fkName() {
    return PeriodicBill.fkName;
  }
  get apiRoute() {
    return PeriodicBill.apiRoute;
  }
  get detailPageRoute() {
    return PeriodicBill.detailPageRoute;
  }
  get listPageRoute() {
    return PeriodicBill.listPageRoute;
  }

  static get joinAttrsKey() {
    return ['number', 'designation', 'beginDate', 'endDate', 'salesAmount'];
  }

  static get entityListDisplayAttrs() {
    return this.getAttributes([
      'number',
      'designation',
      'beginDate',
      'endDate',
      'closed',
      'salesAmount',
    ]);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(
      ['number', 'designation', 'beginDate', 'endDate', 'salesAmount'],
      ['billDate', 'projectPart']
    );
  }

  static get allAttributes() {
    return {
      number: new HitContainerAttribute(ATTRIBUTE_TYPES.STRING, {
        column: 'no',
        tableProperties: {
          header: 'hit-app.common.number',
          maxWidth: '0.5fr',
        },
      }),
      designation: new HitContainerAttribute(ATTRIBUTE_TYPES.STRING, {
        tableProperties: {
          header: 'hit-base.common.designation',
          maxWidth: '2fr',
        },
      }),
      memo: new HitContainerAttribute(ATTRIBUTE_TYPES.STRING, {
        tableProperties: {
          header: 'hit-base.common.memo',
        },
      }),
      beginDate: new HitContainerAttribute(ATTRIBUTE_TYPES.DATE, {
        column: 'begin_date',
        tableProperties: {
          header: 'hit-app.common.begin-date',
          maxWidth: '1fr',
        },
      }),
      endDate: new HitContainerAttribute(ATTRIBUTE_TYPES.DATE, {
        column: 'end_date',
        tableProperties: {
          header: 'hit-app.common.end-date',
          maxWidth: '1fr',
        },
      }),
      billDate: new HitContainerAttribute(ATTRIBUTE_TYPES.DATE, {
        column: 'bill_date',
        tableProperties: {
          header: 'hit-app.common.bill-date',
          maxWidth: '1fr',
        },
      }),
      closed: new HitContainerAttribute(ATTRIBUTE_TYPES.BOOLEAN, {
        tableProperties: {
          header: 'hit-app.common.closed',
          maxWidth: '1fr',
        },
      }),
      salesAmount: new HitContainerAttribute(ATTRIBUTE_TYPES.DECIMAL, {
        column: 'sales_amount',
        tableProperties: {
          header: 'hit-app.common.amount',
          maxWidth: '2fr',
        },
      }),
      projectPart: new HitContainerAttribute(ATTRIBUTE_TYPES.FK_PROJECT_PART, {
        joinPath: ['fk_project_part_bill_project_part_id_project_part'],
        column: 'project_part_id',
        tableProperties: {
          header: 'hit-base.common.project-part',
        },
      }),
      sortOrder: new HitContainerAttribute(ATTRIBUTE_TYPES.STRING, {
        column: 'sort_order',
      }),
    };
  }
}
